export const noLook = {name: 'No look', products: []}
export const loadingLook = {name: 'Loading...', products: []}
